<template>
  <div>
    <InputRow
      :model-value="costCenter.parentId"
      name="parentNode"
      :display-name="t('modules.organization.components.CCTPComponent.parent')"
      :required="!(costCenter.id != null && costCenter.path.split('.').length === 1)"
    >
      <template #default="{ field: inputField }">
        <InputText
          v-if="props.siteId == null"
          :disabled="true"
          class="w-100"
          :placeholder="t('modules.organization.components.CCTPComponent.sitePlaceholder')"
        />
        <CostCenterSelect
          v-else
          v-bind="inputField"
          v-model="costCenter.parentId"
          id-column="path"
          :clearable="false"
          id-type="string"
          :disabled="costCenter.id != null && costCenter.path.split('.').length === 1"
          :variables="variablesForCCSelect"
          :disabled-nodes="
            costCenter.id != null ? [{ key: costCenter.id.toString(), includeChildren: true }] : []
          "
          :show-inline-create="false"
          class="w-100"
        />
      </template>
    </InputRow>

    <InputRow
      v-model="costCenter.code"
      name="label"
      type="text"
      :display-name="t('modules.organization.components.CCTPComponent.codeLabel')"
      required
      :rules="[ltreeSegment(), matches(/^[a-zA-Z0-9]+$/)]"
    />

    <InputRow
      v-model="costCenter.name"
      name="name"
      type="text"
      :display-name="t('modules.organization.components.CCTPComponent.name')"
      required
      :rules="[minLength(1)]"
    />

    <InputRow
      v-model="costCenter.description"
      name="description"
      :display-name="t('modules.organization.components.CCTPComponent.description')"
    >
      <template #default="{ field: inputField }">
        <PrimeVueTextarea
          v-bind="inputField"
          v-model="costCenter.description"
          type="text"
          rows="3"
          data-max="5"
          name="description"
          class="w-100"
        />
      </template>
    </InputRow>
  </div>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { ltreeSegment, matches, minLength } from "@/modules/formValidation";
import { computed } from "vue";
import PrimeVueTextarea from "primevue/textarea";
import InputRow from "@/components/shared/form/InputRow.vue";
import type { CostCenterEditType } from "../helper/CR_TP_Type";
import CostCenterSelect from "./selects/CostCenterSelect.vue";
import InputText from "primevue/inputtext";

const props = defineProps({
  costCenter: {
    type: Object as () => CostCenterEditType,
    required: true,
  },
  siteId: {
    type: Number,
    required: false,
    default: undefined,
  },
});
const variablesForCCSelect = computed(() => {
  return {
    siteIds: [props.siteId!],
  };
});

const { t } = useTranslation();
</script>
